import { useGetCompanyCandidatesQuery, useTechnographicsPrefetch } from 'services';
import { SEARCH_LOADING_SIZE } from 'features/search/models';

import { useTechnographicsFilters } from './use-technographics-filters';

const PAGE_SIZE = 20;
const VIRTUAL_PAGES = SEARCH_LOADING_SIZE / PAGE_SIZE;

export const useGetTechnograpicsCompanies = () => {
	const filters = useTechnographicsFilters();
	const { technographics_page: filtersPage, size, ...filteredFilters } = filters;
	const prefetchPage = useTechnographicsPrefetch('getCompanyCandidates');

	const normalizedPageNumber = Math.floor((PAGE_SIZE * filtersPage) / SEARCH_LOADING_SIZE);

	const { data, isFetching, isError } = useGetCompanyCandidatesQuery({
		...filteredFilters,
		offset: normalizedPageNumber * SEARCH_LOADING_SIZE,
		limit: SEARCH_LOADING_SIZE
	});

	if (filtersPage % VIRTUAL_PAGES === 3) {
		prefetchPage({
			...filteredFilters,
			offset: (normalizedPageNumber + 1) * SEARCH_LOADING_SIZE,
			limit: SEARCH_LOADING_SIZE
		});
	}

	const page = filtersPage || 0;

	const pageNumberOnCurrentSegment = page % (SEARCH_LOADING_SIZE / PAGE_SIZE);

	const pagedResults =
		data?.results.slice(PAGE_SIZE * pageNumberOnCurrentSegment, PAGE_SIZE * (pageNumberOnCurrentSegment + 1)) || [];

	const pagedData = { ...data, results: pagedResults };

	return { data: pagedData, isFetching, isError };
};
